import {
	defaultProductResultDto,
	ProductResultDto,
} from "src/dtos/productResult/ProductResultDto";
import {
	defaultTqcInspectResultDtlDto,
	TqcInspectResultDtlDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";

export interface TQC2011_R01HeaderDto extends ProductResultDto {
	itemGroup: string;
	jobTeamNm: string;
	inspectionCount: number;
	inspectNo: string;
	inspectType: string;
	inspectDt: Date | string | undefined;
	inspectorEmp: string;
	inspectorEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
	inspectRemark: string;
}

export const defaultTQC2011_R01HeaderDto: TQC2011_R01HeaderDto = {
	...defaultProductResultDto,
	itemGroup: "",
	jobTeamNm: "",
	inspectionCount: 0,
	inspectNo: "",
	inspectType: "",
	inspectDt: undefined,
	inspectorEmp: "",
	inspectorEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	inspectRemark: "",
};

export interface TQC2011_R01DetailDto extends TqcInspectResultDtlDto {
	inspItemGroup: string;
	inspType: string;
	inspItemNm: string;
	specValue1: string;
	specRange: string;
	specRangeNm: string;
	specValue2: string;
	specText: string;
	valueType: string;
	valueTypeNm: string;
	inspUnit: string;
	inspMethod: string;
	inspMethodNm: string;
	isModified: boolean;
	inserted: boolean;
}

export const defaultTQC2011_R01DetailDto: TQC2011_R01DetailDto = {
	...defaultTqcInspectResultDtlDto,
	inspItemGroup: "",
	inspType: "",
	inspItemNm: "",
	specValue1: "",
	specRange: "",
	specRangeNm: "",
	specValue2: "",
	specText: "",
	valueType: "",
	valueTypeNm: "",
	inspUnit: "",
	inspMethod: "",
	inspMethodNm: "",
	isModified: false,
	inserted: false,
};

export interface TQC2011_R01Dto {
	header: TQC2011_R01HeaderDto;
	detailList: TQC2011_R01DetailDto[];
}

export const TQC2011_R01_VALUE_FIELDS = [
	"inspectValue1_1",
	"inspectValue1_2",
	"inspectValue1_3",
	"inspectValue1_4",
	"inspectValue1_5",
] as const;
